module.exports = __webpack_public_path__ + "assets/img/pic6.38643cf9.png";